import Raven from 'raven-js';

// Service to send errors to Sentry
const ErrorService = function() {
  const capture = (title = 'Unhandled Exception', extra = {}) => {
    Raven.captureException(new Error(title), { extra });
  };

  const setUserContext = (context = {}) => {
    Raven.setUserContext(context);
  };

  return {
    capture,
    setUserContext,
  };
};

export default new ErrorService();
